// YusufDashboard.jsx

import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Stack,
  Chip
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { db } from "./firebase";
import { getDisplayStatus, getDisplayName } from "./utils/statusLabels";
import { useNavigate } from "react-router-dom";
import { apiFetch, API_BASE } from "./utils/apiClient";
import { useBoxStaff, withBoxStaffNames } from "./utils/useBoxStaff";
import {
  collection,
  onSnapshot,
  doc,
  updateDoc,
  Timestamp,
} from "firebase/firestore";
import { Checkbox, FormControlLabel } from "@mui/material";
import { showBuiltIn } from "./utils/accountBuiltIns";

const YusufDashboard = () => {
  const boxStaff = useBoxStaff();
  // ✅ إخفاء الطلبات عن واجهة المصمم - من صلاحية بنين/المدير فقط (طلب
  // المستخدم). الإخفاء بصري فقط بالداشبورد - الطلب يبقى يمشي بنفس الفلو
  // تماماً، فقط ينتقل لقسم "الطلبات المخفية" بدل القائمة الرئيسية.
  const currentUsername = localStorage.getItem("username");
  const canManageHidden =
    currentUsername === "Baneen@123" || currentUsername === "admin";

  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [view, setView] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [printChoiceDialogOpen, setPrintChoiceDialogOpen] = useState(false);
  const [showAllFromGirls, setShowAllFromGirls] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isWorking, setIsWorking] = useState(false);

const navigate = useNavigate();
const yusufChecklist = [
  "تأكدت من صيغة الملفات CMYK",
  "ضفت اللوكو",
  "خليت مسافة",
  "تأكدت من القياس",
  "تأكدت ماكو شي مكصوص من الصورة",
  "تأكدت ماكو توقيع",
  "تأكدت اللوحة غير مضروبة",
  "تأكدت إذا اللوحة شخصية ما ضفت اللوكو",
];

const [checkedItems, setCheckedItems] = useState({});
  const isChecklistComplete = yusufChecklist.every((t) => checkedItems[t]);
  const [upscaleLink, setUpscaleLink] = useState("");

const [selectedPriority, setSelectedPriority] = useState("all");

// ✅ تبديل إخفاء/إظهار طلب (بنين/المدير فقط - الزر نفسه محمي بـcanManageHidden
// بالواجهة). orders مبني على onSnapshot بالأسفل فتنعكس تلقائياً.
const toggleHiddenFromBoard = async (order) => {
  const hide = !order.hiddenFromBoard;
  const orderRef = doc(db, "orders", order.id);
  await updateDoc(orderRef, {
    hiddenFromBoard: hide,
    hiddenBy: hide ? currentUsername : null,
    hiddenAt: hide ? Timestamp.now() : null,
  });
};

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "orders"), (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const sorted = data.sort(
        (a, b) => a.createdAt?.seconds - b.createdAt?.seconds
      );
      setOrders(sorted);
    });
    return () => unsubscribe();
  }, []);
useEffect(() => {
  const shouldOpen = localStorage.getItem("comparisonDone");
  const targetId = localStorage.getItem("comparisonOrderId");

  if (shouldOpen !== "true" || !targetId) return;

  const targetOrder = orders.find((o) => o.id === targetId);

  // إذا بعده ما وصل الطلب من الفايرستور لا تمسح التخزين وخليها تنتظر
  if (!targetOrder) return;

  // ✅ هنا نفتح البوب اب
  setSelectedOrder(targetOrder);

  const savedChecklist = localStorage.getItem("yusufChecklistTemp");
  if (savedChecklist) {
    setCheckedItems(JSON.parse(savedChecklist));
  }

  const savedUpscaleLink = localStorage.getItem("yusufUpscaleLinkTemp");
  if (savedUpscaleLink) {
    setUpscaleLink(savedUpscaleLink);
  }

  setOpenDialog(true);

  // ✅ ننظف فقط بعد ما نجحنا وفتحنا البوب اب
  localStorage.removeItem("comparisonDone");
  localStorage.removeItem("comparisonOrderId");
  localStorage.removeItem("yusufChecklistTemp");
  localStorage.removeItem("yusufUpscaleLinkTemp");
}, [orders]);



  useEffect(() => {
    let result = [...orders];

    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      result = result.filter((order) => {
        const createdAt = order.createdAt?.toDate?.();
        return createdAt >= from && createdAt <= to;
      });
    }

    setFilteredOrders(result);
  }, [orders, fromDate, toDate]);

// ✅ فلترة الطلبات ليوسف - تبقى كل الطلبات بكل الحالات
const filtered = filteredOrders.filter((order) => {
  const matchesSearch = order.customerName
    ?.toLowerCase()
    .includes(searchTerm.toLowerCase());

  const isFromEmployee = selectedEmployee
    ? order.employee === selectedEmployee
    : true;

  const matchesPriority =
    selectedPriority === "all"
      ? true
      : order.priority === selectedPriority;

  return matchesSearch && isFromEmployee && matchesPriority;
});


  const countAndSum = (condFn) => {
    const filteredList = filteredOrders.filter(condFn);
    const count = filteredList.length;
    const total = filteredList.reduce(
      (sum, o) => sum + (parseFloat(o.price) || 0),
      0
    );
    return { count, total };
  };

  const stats = {
    all: countAndSum(
      (o) =>
        o.status === "عند يوسف" &&
        !o.history?.some((h) => h.status === "مشكلة")
    ),
    returned: countAndSum(
      (o) =>
        o.status === "عند يوسف" &&
        o.history?.some((h) => h.status === "مشكلة")
    ),
    completed: countAndSum(
      (o) =>
        o.history?.some(
          (h) => (h.by === "يوسف" || h.by === "المصمم") && h.status === "عند برهان"
        )
    ),
    rand: countAndSum((o) => o.employee === "رند" && o.status === "عند يوسف"),
    jumana: countAndSum(
      (o) => o.employee === "جمانا" && o.status === "عند يوسف"
    ),
    sara: countAndSum((o) => o.employee === "ساره" && o.status === "عند يوسف"),
    maryam: countAndSum((o) => o.employee === "مريم" && o.status === "عند يوسف"),
      farah: countAndSum((o) => o.employee === "فرح" && o.status === "عند يوسف"),
     Baneen: countAndSum((o) => o.employee === "بنين" && o.status === "عند يوسف"),
    karina: countAndSum((o) => o.employee === "تيهان" && o.status === "عند يوسف"),
      maaysa: countAndSum((o) => o.employee === "مياسة" && o.status === "عند يوسف"),
    fromGirls: countAndSum((o) =>
      withBoxStaffNames(["رند", "جمانا", "مريم", "تيهان", "بنين", "فرح", "مياسة"], boxStaff).includes(o.employee)
    ),
  };
const handleUpdateStatus = async (newStatus, printChoice) => {
  if (!selectedOrder) return;
  // ❌ منع إرسال الطلب للورشة إذا المصمم لم يرفع اللوحة المطبوعة أو رابط UpScale
if (newStatus === "عند برهان") {
  const printed = selectedOrder?.compareBoards?.printedBoard;

  if (!printed || (Array.isArray(printed) && printed.length === 0)) {
    alert("⚠️ يجب رفع اللوحة المطبوعة قبل إرسال الطلب إلى الورشة.");
    return;
  }

  if (!upscaleLink.trim()) {
    alert("⚠️ يجب إدخال رابط اللوحات (UpScale) قبل إرسال الطلب إلى الورشة.");
    return;
  }

  const orderRef = doc(db, "orders", selectedOrder.id);

  const durationUpdate = selectedOrder.startTime
    ? {
        durationByYusuf: Math.ceil(
          (new Date() - selectedOrder.startTime.toDate()) / 60000
        ),
      }
    : { startTime: Timestamp.now() };

  if (printChoice === "internal") {
    // ✅ مطبعة الشركة: بوابة حقيقية - الطلب ينحبس عند المطبعة ولا يوصل للورشة
    // إلا بعد ما تضغط المطبعة "تمت الطباعة" (PrintDashboard.js)
    await updateDoc(orderRef, {
      status: "عند المطبعة",
      printStatus: "طباعة",
      printArrivedAt: Timestamp.now(),
      printChoice: "internal",
      upscaleLink: upscaleLink.trim(),
      ...durationUpdate,
      history: [
        ...(selectedOrder.history || []),
        { status: "عند المطبعة", by: "المصمم", timestamp: Timestamp.now() },
      ],
    });

    // ✅ إشعار المطبعة فقط
    try {
      await fetch("http://localhost:8080/send-to-user", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          uid: "print@123",
          title: "📦 طلب جديد من المصمم",
          body: `تم إرسال طلب جديد من المصمم إلى المطبعة.`,
        }),
      });
      console.log("✅ إشعار المطبعة تم إرساله بنجاح!");
    } catch (error) {
      console.error("❌ فشل إرسال الإشعار إلى المطبعة:", error);
    }

    setCheckedItems({});
    setUpscaleLink("");
    localStorage.removeItem("yusufChecklistTemp");

    setPrintChoiceDialogOpen(false);
    setOpenDialog(false);
    alert("✅ تم الإرسال بنجاح");
    return;
  }

  // ✅ مطبعة خارجية: نفس الفلو القديم قبل إضافة واجهة المطبعة - يروح مباشرة للورشة
  await updateDoc(orderRef, {
    status: "عند برهان",
    printChoice: "external",
    upscaleLink: upscaleLink.trim(),
    ...durationUpdate,
    history: [
      ...(selectedOrder.history || []),
      { status: "عند برهان", by: "المصمم", timestamp: Timestamp.now() },
    ],
  });

  // ✅ إشعار الورشة فقط
  try {
    await fetch("http://localhost:8080/send-to-user", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        uid: "art@1234",
        title: "📦 طلب جديد من المصمم",
        body: `تم إرسال طلب جديد من المصمم إلى الورشة.`,
      }),
    });
    console.log("✅ إشعار الورشة تم إرساله بنجاح!");
  } catch (error) {
    console.error("❌ فشل إرسال الإشعار إلى الورشة:", error);
  }

  // ✅ تصفير الـ checklist بعد الإرسال
  setCheckedItems({});
  setUpscaleLink("");
  localStorage.removeItem("yusufChecklistTemp");

  setPrintChoiceDialogOpen(false);
  setOpenDialog(false);
  alert("✅ تم الإرسال بنجاح");
  return;
}

  const orderRef = doc(db, "orders", selectedOrder.id);

  const updates = {
    status: newStatus,
    history: [
      ...selectedOrder.history,
      { status: newStatus, by: "المصمم", timestamp: Timestamp.now() },
    ],
  };

  // 🔸 حالة "إعادة إلى الموظفة"
  if (newStatus === "اعادة الى الموظفة") {
    let targetUid = null;

    // نحدد المستخدم حسب اسم الموظفة اللي أنشأت الطلب
    switch (selectedOrder.employee) {
      case "رند":
        targetUid = "rand@123";
        break;
      case "جمانا":
        targetUid = "jumana@123";
        break;
      case "ساره":
        targetUid = "sara@123";
        break;
         case "بنين":
        targetUid = "Baneen@123";
        
        break;
          case "مريم":
        targetUid = "maryam@123";
        break;
         case "فرح":
        targetUid = "farah@123";
        break;
          case "تيهان":
        targetUid = "karina@123";
        break;
          case "مياسة":
        targetUid = "maysa@123";
      default:
        console.warn("⚠️ لم يتم تحديد الموظفة المستهدفة.");
        break;
    }

    if (targetUid) {
      try {
        await fetch("http://localhost:8080/send-to-user", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            uid: targetUid,
            title: "🔁 تم إعادة الطلب",
            body: `تمت إعادة الطلب من المصمم إلى ${selectedOrder.employee} للتعديل.`,
          }),
        });
        console.log(`✅ إشعار أُرسل إلى ${selectedOrder.employee}`);
      } catch (error) {
        console.error("❌ فشل إرسال الإشعار إلى الموظفة:", error);
      }
    }
  }

  // باك اند يوسف
  await apiFetch(`${API_BASE}/orders/${selectedOrder.id}`, {
  method: "PUT",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
    status: newStatus,
  }),
});



  // ✅ تصفير الـ checklist بعد الإرسال
setCheckedItems({});
setUpscaleLink("");
localStorage.removeItem("yusufChecklistTemp");

  setOpenDialog(false);
};


  const monthlyStats = {};
  orders.forEach((order) => {
    const date = order.createdAt?.toDate();
    if (date) {
      const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
      if (!monthlyStats[key]) monthlyStats[key] = { count: 0, total: 0 };
      monthlyStats[key].count += 1;
      monthlyStats[key].total += parseFloat(order.price) || 0;
    }
  });

  const monthlyArray = Object.entries(monthlyStats).sort(([a], [b]) => b.localeCompare(a));
const PriorityBadge = ({ priority }) => {
  if (!priority) return null;

  const map = {
    High: {
      label: "HIGH",
      bg: "#d32f2f",
      color: "#fff",
      border: "#b71c1c",
      icon: "🔴",
    },
    Medium: {
      label: "MEDIUM",
      bg: "#f9a825",
      color: "#000",
      border: "#f57f17",
      icon: "🟡",
    },
    Low: {
      label: "LOW",
      bg: "#2e7d32",
      color: "#fff",
      border: "#1b5e20",
      icon: "🟢",
    },
  };

  const p = map[priority];

  return (
    <Box
      sx={{
        px: 2,
        py: 0.8,
        borderRadius: "999px", // شكل تاك حقيقي
        fontWeight: 900,
        fontSize: 14,
        backgroundColor: p.bg,
        color: p.color,
        border: `2px solid ${p.border}`,
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
        letterSpacing: 1,
      }}
    >
      <span>{p.icon}</span>
      <span>{p.label}</span>
    </Box>
  );
};


  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h5" align="right">
        المصمم
      </Typography>
<Box display="flex" flexWrap="wrap" gap={2} mb={3}>
 {showBuiltIn("box:myTasks") && (
 <Button
  variant="contained"
  color="secondary"
  onClick={() => navigate("/yusuf-tasks")}
>
  📋 مهامي
</Button>
 )}
  {showBuiltIn("box:todo") && (
  <Button variant="outlined" onClick={() => navigate("/todo")}>
    TO-DO LIST 📋
  </Button>
  )}
 {showBuiltIn("extra:socialMedia") && (
 <Button
  variant="contained"
  color="primary"
  onClick={() => window.open("https://admin-artika.netlify.app/login", "_blank")}
  sx={{ borderRadius: 2, fontWeight: 700 }}
>
إدارة منشورات التواصل الاجتماعي</Button>
 )}


{showBuiltIn("box:leaveRequest") && (
<Button
  variant="contained"
  color="info"
onClick={() => navigate("/leave-request?u=designer@123&returnTo=/designer")}
>
   طلب إجازة
</Button>
)}

{showBuiltIn("extra:allStageVideos") && (
<Button
  variant="contained"
  sx={{ backgroundColor: "#546e7a", "&:hover": { backgroundColor: "#455a64" } }}
  onClick={() => navigate("/all-stage-videos")}
>
  🎬 فيديوات كل المراحل
</Button>
)}

</Box>



      <TextField
        fullWidth
        sx={{ mt: 2 }}
        label="🔍 ابحث عن اسم الزبون"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

<Box mt={2} display="flex" gap={1} flexWrap="wrap">
  <Button
    variant={selectedEmployee === null ? "contained" : "outlined"}
    onClick={() => setSelectedEmployee(null)}
  >
    👥 الكل
  </Button>

  <Button
    variant={selectedEmployee === "بنين" ? "contained" : "outlined"}
    onClick={() => setSelectedEmployee("بنين")}
  >
    بنين
  </Button>

  <Button
    variant={selectedEmployee === "ساره" ? "contained" : "outlined"}
    onClick={() => setSelectedEmployee("ساره")}
  >
    سارة
  </Button>


  <Button
    variant={selectedEmployee === "جمانا" ? "contained" : "outlined"}
    onClick={() => setSelectedEmployee("جمانا")}
  >
    جمانا
  </Button>
  <Button
    variant={selectedEmployee === "تيهان" ? "contained" : "outlined"}
    onClick={() => setSelectedEmployee("تيهان")}
  >
    تيهان
  </Button>

  <Button
    variant={selectedEmployee === "مياسة" ? "contained" : "outlined"}
    onClick={() => setSelectedEmployee("مياسة")}
  >
    مياسة
  </Button>

  
  <Button
    variant={selectedEmployee === "رند" ? "contained" : "outlined"}
    onClick={() => setSelectedEmployee("رند")}
  >
    رند
  </Button>

  {/* موظفات البوكسات (الحسابات الجديدة مثل تيهان) تلقائياً */}
  {boxStaff
    .filter((staff) => !["بنين", "ساره", "جمانا", "تيهان", "مياسة", "رند"].includes(staff.displayName))
    .map((staff) => (
    <Button
      key={staff.username}
      variant={selectedEmployee === staff.displayName ? "contained" : "outlined"}
      onClick={() => setSelectedEmployee(staff.displayName)}
    >
      {staff.displayName}
    </Button>
  ))}
</Box>
<Box mt={2} display="flex" gap={1} flexWrap="wrap">
  <Button
    variant={selectedPriority === "all" ? "contained" : "outlined"}
    onClick={() => setSelectedPriority("all")}
  >
    ⚡ كل الأولويات
  </Button>

  <Button
    variant={selectedPriority === "High" ? "contained" : "outlined"}
    color="error"
    onClick={() => setSelectedPriority("High")}
  >
    🔴 High
  </Button>

  <Button
    variant={selectedPriority === "Medium" ? "contained" : "outlined"}
    color="warning"
    onClick={() => setSelectedPriority("Medium")}
  >
    🟡 Medium
  </Button>

  <Button
    variant={selectedPriority === "Low" ? "contained" : "outlined"}
    color="success"
    onClick={() => setSelectedPriority("Low")}
  >
    🟢 Low
  </Button>
</Box>

      

   
<Box mt={3}>
  {/* ✅ الطلبات غير المكتملة (عند المصمم فقط) */}
  <Typography variant="h6" color="primary" sx={{ mb: 1 }}>
    🟢 الطلبات غير المكتملة (عند المصمم)
  </Typography>
  {(() => {
    const incompleteOrders = filtered
      .filter(
        (order) =>
          order.status === "عند يوسف" &&
          (!order.hiddenFromBoard || canManageHidden)
      )
      .sort((a, b) => a.createdAt?.seconds - b.createdAt?.seconds) // الأقدم -> الأحدث
      .sort((a, b) =>
        a.hiddenFromBoard === b.hiddenFromBoard ? 0 : a.hiddenFromBoard ? 1 : -1
      ); // ✅ الطلبات المخفية (بنين/المدير فقط) تنكوم بالآخر
    const firstHiddenIncompleteIndex = incompleteOrders.findIndex(
      (o) => o.hiddenFromBoard
    );

    return incompleteOrders.map((order, index) => {
      const cardContent = (
      <Box
        key={order.id}
        sx={{
          mb: 2,
          p: 2,
          bgcolor: "#fffde7",
          borderRadius: 2,
          boxShadow: 2,
          border: "1px solid #fbc02d",
          position: "relative",

        }}
      >
        <Box
  sx={{
    position: "absolute",
    top: 12,
    left: 12, // 👈 الجهة المقابلة مثل الصورة
    display: "flex",
    alignItems: "center",
    gap: 1,
  }}
>
  <PriorityBadge priority={order.priority} />
  {canManageHidden && (
    <Chip
      size="small"
      clickable
      onClick={() => toggleHiddenFromBoard(order)}
      label={order.hiddenFromBoard ? "👁️ إظهار" : "🚫 إخفاء"}
      sx={{
        fontWeight: 700,
        color: "#fff",
        backgroundColor: order.hiddenFromBoard ? "#2e7d32" : "rgba(0,0,0,0.55)",
        "&:hover": {
          backgroundColor: order.hiddenFromBoard ? "#1b5e20" : "rgba(0,0,0,0.7)",
        },
      }}
    />
  )}
</Box>

        <Typography fontWeight="bold">
    التاريخ   :    {order.createdAt ? new Date(order.createdAt.seconds * 1000).toLocaleDateString() : "—"}
</Typography>

       <Typography fontWeight="bold">
  👤 {order.customerName}
  {" | "}
    من: {order.employee}
  {" | "}
  🏙️ {order.governorate}
  {" | "}
  🟢 الحالة: {getDisplayStatus(order.status, order)}
</Typography>
<Typography fontWeight="bold">
  🧩 عدد اللوحات: {order.boardsCount || "—"}
  {order.withDrawing && (
    <> | 🎨 عدد لوحات الرسم: {order.drawingBoardsCount || "—"}</>
  )}
</Typography>



        <Typography fontWeight="bold">
          🔗 <a href={order.https} target="_blank" rel="noreferrer">فتح الرابط</a>
        </Typography>
        {order.note && (
          <Typography fontWeight="bold">📝 {order.note}</Typography>
        )}
        {order.designerNote && (
          <Typography fontWeight="bold" color="primary">🎨 ملاحظات للمصمم: {order.designerNote}</Typography>
        )}
        {order.driveLink && (
          <Typography fontWeight="bold" color="primary">
            🎥 فيديو حليمة:{" "}
            <a href={order.driveLink} target="_blank" rel="noreferrer">فتح الفيديو</a>
          </Typography>
        )}

        {/* الأزرار */}
        {!order.startTime && (
          <Button
            onClick={async () => {
              const orderRef = doc(db, "orders", order.id);
              await updateDoc(orderRef, { startTime: Timestamp.now() });
              setIsWorking(true);
            }}
            sx={{ mt: 1, mr: 1, bgcolor: "#ffeb3b", color: "#000" }}
            variant="contained"
          >
            🚀 بدء العمل
          </Button>
        )}
{/* زر مقارنة اللوحات ورفع اللوحة المطبوعة */}

        {order.startTime && (
          
       <Button
  onClick={() => {
    setSelectedOrder(order);
    setUpscaleLink(order.upscaleLink || "");
    setOpenDialog(true);
  }}
  sx={{ mt: 1 }}
  variant="contained"
  color="primary"
>
  🔄 تحديث
</Button>


        )}
      </Box>
      );

      if (order.hiddenFromBoard && !canManageHidden) return null;

      // ✅ طلب مخفي وعندك صلاحية - يظهر بنفس شكله بالضبط جوا "طلبات مخفية"
      if (order.hiddenFromBoard) {
        return (
          <React.Fragment key={order.id}>
            {index === firstHiddenIncompleteIndex && (
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2, mb: 1 }}>
                🚫 طلبات مخفية
              </Typography>
            )}
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography fontWeight="bold">
                  {order.customerName} — {getDisplayStatus(order.status, order)}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>{cardContent}</AccordionDetails>
            </Accordion>
          </React.Fragment>
        );
      }

      return cardContent;
    });
  })()}
  {/* ✅ بقية الطلبات */}
  <Typography variant="h6" color="secondary" sx={{ mt: 3, mb: 1 }}>
    📋 بقية الطلبات
  </Typography>
  {/* ⚠️ بطلب المستخدم: الإخفاء يصير فقط على الطلبات غير المكتملة (القسم
      أعلاه) - هذا القسم رجع لشكله الأصلي بدون أي منطق إخفاء/إظهار */}
  {filtered
  .filter((order) => order.status !== "عند يوسف" || order.startTime)
  .sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds) // الأحدث -> الأقدم
  .map((order) => (
      <Box
        key={order.id}
        sx={{
          mb: 2,
          p: 2,
          bgcolor: "#e8f5e9",
          borderRadius: 2,
          boxShadow: 2,
          border: "1px solid #4caf50",
        }}
      >
       <Typography fontWeight="bold">
  👤 {order.customerName}
  {" | "}
    من: {order.employee}
  {" | "}
  🟢 الحالة: {getDisplayStatus(order.status, order)}
  {" | "}
  🏙️ {order.governorate}
</Typography>

        <Typography fontWeight="bold">
          🔗 <a href={order.https} target="_blank" rel="noreferrer">فتح الرابط</a>
        </Typography>
        {order.note && (
          <Typography fontWeight="bold">📝 {order.note}</Typography>
        )}
        {order.designerNote && (
          <Typography fontWeight="bold" color="primary">🎨 ملاحظات للمصمم: {order.designerNote}</Typography>
        )}
        {order.driveLink && (
          <Typography fontWeight="bold" color="primary">
            🎥 فيديو حليمة:{" "}
            <a href={order.driveLink} target="_blank" rel="noreferrer">فتح الفيديو</a>
          </Typography>
        )}

        {/* 👇 تفاصيل الحالة (history) */}
        <Accordion sx={{ mt: 1 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            عرض الحالة
          </AccordionSummary>
       <AccordionDetails>
  {order.history
    ?.sort((a, b) => a.timestamp?.seconds - b.timestamp?.seconds) // الأقدم → الأحدث
    .map((item, i) => (
      <Box key={i} sx={{ mb: 1 }}>
        <Typography fontWeight="bold">
          🔸 {getDisplayStatus(item.status)} - 👤 {getDisplayName(item.by)} - 🕓{" "}
          {item.timestamp
            ? new Date(item.timestamp.seconds * 1000).toLocaleString()
            : "بدون وقت"}
        </Typography>
        {(item.note || item.notes || item.comment) && (
          <Typography sx={{ ml: 3, color: "red" }}>
            📝 {item.note || item.notes || item.comment}
          </Typography>
        )}
      </Box>
    ))}
</AccordionDetails>

        </Accordion>
      </Box>
    ))}

</Box>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>تحديث حالة الطلب</DialogTitle>
        <DialogContent>
          <Typography>👤 الزبون: {selectedOrder?.customerName}</Typography>
          <Typography>
            🔗 <a href={selectedOrder?.https} target="_blank" rel="noreferrer">فتح الرابط</a>
          </Typography>
<Box mt={2} sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2 }}>
  <Typography fontWeight={700} sx={{ mb: 1 }}>
    ✅ Check List (لازم تكملها قبل الإرسال)
  </Typography>

  {yusufChecklist.map((text, idx) => (
    <FormControlLabel
      key={idx}
      sx={{ display: "flex" }}
      control={
        <Checkbox
          checked={!!checkedItems[text]}
          onChange={(e) =>
            setCheckedItems((prev) => ({
              ...prev,
              [text]: e.target.checked,
            }))
          }
        />
      }
      label={text}
    />
  ))}
</Box>

<TextField
  fullWidth
  sx={{ mt: 2 }}
  label="رابط اللوحات (UpScale)"
  value={upscaleLink}
  onChange={(e) => setUpscaleLink(e.target.value)}
  required
/>

        </DialogContent>
  <DialogActions sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
  {/* 🟢 زر إرسال الطلب إلى المطبعة */}

 <Button
  variant="outlined"
  color="secondary"
  fullWidth
  onClick={() => {
    if (!selectedOrder) return;

    localStorage.setItem("comparisonDone", "true");
    localStorage.setItem("comparisonOrderId", selectedOrder.id);

    // حفظ الـ checklist والرابط حتى ما يضيعوا
    localStorage.setItem("yusufChecklistTemp", JSON.stringify(checkedItems));
    localStorage.setItem("yusufUpscaleLinkTemp", upscaleLink);

    navigate(`/compare-boards/${selectedOrder.id}`);
  }}
>
  🖼️ تحديث اللوحة المطبوعة (مقارنة اللوحات)
</Button>


  <Button
  variant="contained"
  color="primary"
  fullWidth
  disabled={!isChecklistComplete || !upscaleLink.trim()}
  onClick={() => setPrintChoiceDialogOpen(true)}
>
 إرسال إلى المطبعة
</Button>


  {/* 🟠 زر إعادة الطلب للموظفة */}
 
{!isChecklistComplete && (
  <Typography sx={{ color: "red", fontWeight: "bold", textAlign: "center" }}>
    ⚠️ لازم تكمّل كل الـ Check List قبل الإرسال
  </Typography>
)}
  {/* ⚪ زر إغلاق */}
  <Button fullWidth onClick={() => setOpenDialog(false)}>
    إغلاق
  </Button>

</DialogActions>

      </Dialog>

      <Dialog open={printChoiceDialogOpen} onClose={() => setPrintChoiceDialogOpen(false)}>
        <DialogTitle>وين ترسل الطلب؟</DialogTitle>
        <DialogContent>
          <Typography>اختر جهة الطباعة قبل إرسال الطلب.</Typography>
        </DialogContent>
        <DialogActions sx={{ display: "flex", flexDirection: "column", gap: 1, p: 2 }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => handleUpdateStatus("عند برهان", "internal")}
          >
            🏭 إرسال إلى مطبعة الشركة
          </Button>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            onClick={() => handleUpdateStatus("عند برهان", "external")}
          >
            🚚 إرسال إلى مطبعة خارجية
          </Button>
          <Button fullWidth onClick={() => setPrintChoiceDialogOpen(false)}>
            إلغاء
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default YusufDashboard;
